import { render, staticRenderFns } from "./buildMng.vue?vue&type=template&id=18ea4dbc&scoped=true"
import script from "./buildMng.vue?vue&type=script&lang=js"
export * from "./buildMng.vue?vue&type=script&lang=js"
import style0 from "./buildMng.vue?vue&type=style&index=0&id=18ea4dbc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18ea4dbc",
  null
  
)

export default component.exports